import * as React from 'react'
import css from './Toggle.module.scss'
import { LoadingSpinner } from '../LoadingSpinner'

interface ToggleProps {
	id?: string
	checked?: boolean
	disabled?: boolean
	isLoading?: boolean
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const Toggle: React.FunctionComponent<ToggleProps> = ({ id, checked, disabled, onChange, isLoading }) => (
		<label htmlFor={id} className={`${css['toggle']} ${disabled ? css.disabled : ''}`}>
			{isLoading && (
				<div className={css.loadingSpinnerContainer}>
					<LoadingSpinner />
				</div>
			)}
			<input id={id} type="checkbox" checked={checked} disabled={disabled} onChange={onChange} aria-label="toggle" />
			<span className={css['toggle-slider']}></span>
		</label>
	)
